import React, { useState } from "react";
import { FaGithub, FaLinkedin, FaFileDownload } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { motion } from "framer-motion";
import resumePDF from "../assets/CV.pdf"; // Update path

const SocialLinks = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState(false);

  const links = [
    {
      id: 1,
      name: "",
      icon: <FaLinkedin className="text-[#0A66C2]" />,
      href: "https://www.linkedin.com/in/mohammed-yassine-aoulad-ahriz",
      color: "hover:bg-[#0A66C2]/10",
    },
    {
      id: 2,
      name: "",
      icon: <FaGithub className="text-gray-100" />,
      href: "https://github.com/mohammedyassinAa",
      color: "hover:bg-gray-700/50",
    },
    {
      id: 3,
      name: "",
      icon: <HiOutlineMail className="text-red-400" />,
      action: () => {
        navigator.clipboard.writeText("yssnmed@gmail.com");
        setCopiedEmail(true);
        setTimeout(() => setCopiedEmail(false), 2000);
      },
      color: "hover:bg-red-500/10",
    },
    {
      id: 4,
      name: "",
      icon: <FaFileDownload className="text-cyan-400" />,
      href: resumePDF,
      download: "CV.pdf",
      color: "hover:bg-cyan-500/10",
    },
  ];

  return (
    <>
      {/* Mobile Bottom Bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-gray-900/80 backdrop-blur-sm z-50 border-t border-gray-700">
        <div className="flex justify-around py-3">
          {links.map((link) => (
            <motion.a
              key={link.id}
              whileTap={{ scale: 0.9 }}
              href={link.href}
              onClick={(e) => {
                if (link.action) {
                  e.preventDefault();
                  link.action();
                }
              }}
              download={link.download}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex flex-col items-center p-2 rounded-lg ${link.color} transition-colors`}
            >
              <div className="text-2xl">{link.icon}</div>
              <span className="text-xs mt-1">{link.name}</span>
              {link.id === 3 && copiedEmail && (
                <span className="absolute -top-8 bg-gray-800 px-2 py-1 rounded text-xs">
                  Copied!
                </span>
              )}
            </motion.a>
          ))}
        </div>
      </div>

      {/* Desktop Side Panel */}
      <motion.div
        initial={{ x: -160 }}
        animate={{ x: isExpanded ? 0 : -120 }}
        whileHover={{ x: 0 }}
        onHoverStart={() => setIsExpanded(true)}
        onHoverEnd={() => setIsExpanded(false)}
        className="hidden lg:flex flex-col fixed left-0 top-1/3 z-50"
      >
        <div className="flex">
          <div className="bg-gray-900/80 backdrop-blur-sm border-r-0 border border-gray-700 rounded-r-lg overflow-hidden">
            <ul className="space-y-1 p-2">
              {links.map((link) => (
                <li key={link.id}>
                  <motion.a
                    whileHover={{ x: 5 }}
                    whileTap={{ scale: 0.95 }}
                    href={link.href}
                    onClick={(e) => {
                      if (link.action) {
                        e.preventDefault();
                        link.action();
                      }
                    }}
                    download={link.download}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center gap-3 p-3 rounded-lg ${link.color} transition-colors`}
                  >
                    <div className="text-2xl">{link.icon}</div>
                    {isExpanded && (
                      <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="whitespace-nowrap"
                      >
                        {link.name}
                      </motion.span>
                    )}
                    {link.id === 3 && copiedEmail && (
                      <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="absolute left-full ml-2 bg-gray-800 px-2 py-1 rounded text-xs whitespace-nowrap"
                      >
                        Email copied!
                      </motion.span>
                    )}
                  </motion.a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default SocialLinks;